import { Box, Image } from '@dtx-company/shared-components/src'
import { LockModalGraphic } from '../../../constants/lockModal'
import { LottieAnimation } from '@dtx-company/shared-components/src/components/molecules/LottieAnimation'
import NextImage from 'next/image'
import React from 'react'

export const PromoAsset = ({
  graphic
}: {
  graphic: LockModalGraphic | undefined
}): JSX.Element | null => {
  if (!graphic?.src) return null
  if (graphic.width && graphic.height) {
    return (
      <NextImage
        src={graphic.src}
        alt={graphic.alt || ''}
        height={graphic.height}
        width={graphic.width}
      />
    )
  }
  return (
    <>
      <Box position={'relative'} m={'auto'} width={250}>
        <Image src={graphic.src} alt={graphic.alt} />
        {graphic?.lottie?.url && (
          // The only current lottie animation is one that needs to overlay and
          // shift down slightly to line up - to support more in the future
          // may need to update the LockModalGraphics data to have components
          // for the promoAsset directly instead of this structure that's been
          // adapted from the previous code
          <Box
            position={'absolute'}
            style={{ top: 0, right: 0, bottom: 0, left: 0, paddingTop: '32px' }}
          >
            <LottieAnimation animation={graphic.lottie.url} autoplay />
          </Box>
        )}
      </Box>
    </>
  )
}
